module.exports = __webpack_public_path__ + "static/media/about4.695db610.jpeg";